<template>
  <div>
    <page-main
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @refresh="refresh"
      />
      <pagination
        size="mini"
        align="right"
        slot="pager"
        :layouts="['Total', 'Sizes', 'PrevPage', 'NextPage']"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import store from '../../store'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: {
    PageMain,
    PageHeader,
  },
  mixins: [BaseTable, EditLoading],
  data() {
    return {
      usePage: true,
    }
  },
  computed: {
    selected() {
      return store.state.selected
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .masterBizDictListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          store.commit('setSelected', this.tableData[0])
        })
        .catch(() => {
          this.loading = false
        })
    },
    refresh() {
      this.loadingOpen()
      this.$api
        .masterBizDictOptionsRefreshRedisApi({ dictType: 'all' })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
  },
}
</script>
